// linkJumper.js

// component to travel/jump to and display a particular tx/post - shared by a friend


import {Component} from 'react';

import { Button, Checkbox, Icon, Loader, Modal, Popup } from 'semantic-ui-react'

import {
  getProviderContext,
  mySleep, execAsync,

  hexByteToAscii, hexStringToAscii,

  findNextTxFromProvider, checkForIDBPerms,

  decomposeRawTx, parseInputs, decodeScriptsToState, getUsefulInputParams,

  maybeDecryptContent,

  getRawInfo,

  associateInputWithOutput,

  GENESIS_APPEND
} from '../node_modules/shizzle-core/dist/es/shizzle-core.js'

import { bshzColors } from './bshzColors';

import ContentPresenter from './contentPresenter.js';

import Toast from './toast.js'

//import cytoscape from 'cytoscape';
import CytoscapeComponent from 'react-cytoscapejs';

class LinkJumper extends Component {
  constructor(props) {
    super(props);

    const pathLen = this.props.path.length;

    //this.props.bsvPriceUSD    // will be used to convert satoshi payments to dollars, cents (based on price for a given day)

    this.searchStarted = false;       // used (with state.searchStarted) to trigger from render()

    this.state = {
      idbSupported: false,            // not strictly necessary for linkJumper
      dbPerms: false,
      haveAskedForPerms: false,
      showAreYouSureModal: false,     // to maybe DELETE IDB data

      showLoader: true,

      searchStarted: false,           // used (with this.searchStarted) to trigger from render()

      explainMore: false,

      domainLHS: null,
      domainCharBeingSought: null,
      domainRHS: this.props.path[0],
      phase: 0,
      deepestPhase: pathLen < 4 ?
                        3
                      :
                        pathLen < 6 ?
                            4
                          :
                            pathLen < 8 ?
                                5
                              :
                                pathLen < 9 ?
                                    6
                                  :
                                    pathLen < 10 ?
                                        7
                                      :
                                        pathLen < 11 ?
                                            8
                                          :
                                            pathLen < 12 ?    // expanded from constant 9 here
                                                9
                                              :
                                                pathLen < 13 ?
                                                    10
                                                  :
                                                    pathLen < 14 ?
                                                        11
                                                      :
                                                        pathLen < 15 ?    // expanded FURTHER from constant 12 here
                                                            12
                                                          :
                                                            pathLen < 16 ?
                                                                13
                                                              :
                                                                14,


      deepestTLevel: pathLen < 8 ?
                        9
                      :
                        pathLen < 9 ?
                            8
                          :
                            pathLen < 10 ?
                                7
                              :
                                pathLen < 11 ?
                                    6
                                  :
                                    pathLen < 12 ?   //0,        // expanded from constant 0 here
                                        5
                                      :
                                        pathLen < 13 ?
                                            4
                                          :
                                            pathLen < 14 ?
                                                3
                                              :
                                                pathLen < 15 ?      // expanded FUTHER from constant 0 here
                                                    2
                                                  :
                                                    pathLen < 16 ?
                                                        1
                                                      :
                                                        0,
      linkRHS: [
          // [0]
          <>
            { pathLen < 4 ?
                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}</>  //domain + OwnerCount + quarterly
                    :
                      pathLen < 6 ?
                              <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}</>   //d+oc+q + U/periodical
                            :
                              pathLen < 7 ?
                                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}</>   //d+oc+q + U/periodical + T
                                    :
                                      pathLen < 8 ?
                                              <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}</>    //d+oc+q + U/periodical + T/T9
                                            :
                                              pathLen < 9 ?
                                                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}</> //d+oc+q + U/periodical + T/T9 + T8
                                                    :
                                                      pathLen < 10 ?
                                                              <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}</>   //d+oc+q + U/periodical + T/T9 + T8 + T7
                                                            :
                                                              pathLen < 11 ?
                                                                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6
                                                                    : // EXPAND FROM HERE
                                                                      pathLen < 12 ?
                                                                              <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5
                                                                            :
                                                                              pathLen < 13 ?
                                                                                        <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4
                                                                                      :
                                                                                        pathLen < 14 ?
                                                                                                  <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3
                                                                                                : // EXPAND below, from constant
                                                                                                  pathLen < 15 ?
                                                                                                            <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                                                          :
                                                                                                            pathLen < 16 ?
                                                                                                                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                                                    :
                                                                                                                      <>{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  //d+oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0


            }
          </>,
          // [1]
          <>
            { pathLen < 4 ?
                      <>{this.props.path[1]}/{this.props.path[2]}</>  // OwnerCount + quarterly
                    :
                      pathLen < 6 ?
                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}</>   //oc+q + U/periodical
                            :
                              pathLen < 7 ?
                                      <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}</>   //oc+q + U/periodical + T
                                    :
                                      pathLen < 8 ?
                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}</>    //oc+q + U/periodical + T/T9
                                            :
                                              pathLen < 9 ?
                                                      <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}</> //oc+q + U/periodical + T/T9 + T8
                                                    :
                                                      pathLen < 10 ?
                                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}</>   //oc+q + U/periodical + T/T9 + T8 + T7
                                                            :
                                                              pathLen < 11 ?
                                                                      <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  //oc+q + U/periodical + T/T9 + T8 + T7 + T6
                                                                    :  // EXPANDE FROM HERE
                                                                      pathLen < 12 ?
                                                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  //oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5
                                                                            :
                                                                              pathLen < 13 ?
                                                                                      <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  //oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4
                                                                                    :
                                                                                      pathLen < 14 ?
                                                                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  //oc+q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3
                                                                                            : // EXPAND below, from constant
                                                                                              pathLen < 15 ?
                                                                                                      <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  //oc+q + U/periodical + T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                                                    :
                                                                                                      pathLen < 16 ?
                                                                                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  //oc+q + U/periodical + T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                                            :
                                                                                                              <>{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  //oc+q + U/periodical + T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [2]
          <>
            { pathLen < 4 ?
                      <>{this.props.path[2]}</>  // quarterly
                    :
                      pathLen < 6 ?
                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}</>   // q + U/periodical
                            :
                              pathLen < 7 ?
                                      <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}</>   // q + U/periodical + T
                                    :
                                      pathLen < 8 ?
                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}</>    // q + U/periodical + T/T9
                                            :
                                              pathLen < 9 ?
                                                      <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}</> // q + U/periodical + T/T8 + T8
                                                    :
                                                      pathLen < 10 ?
                                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}</>   // q + U/periodical + T/T9 + T8 + T7
                                                            :
                                                              pathLen < 11 ?
                                                                      <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6
                                                                    : //EXPANDED from here
                                                                      pathLen < 12 ?
                                                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5
                                                                            :
                                                                              pathLen < 13 ?
                                                                                      <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4
                                                                                    :
                                                                                      pathLen < 14 ?
                                                                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3
                                                                                            :   // EXPAND below, from constant
                                                                                              pathLen < 15 ?
                                                                                                      <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                                                    :
                                                                                                      pathLen < 16 ?
                                                                                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                                            :
                                                                                                              <>{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // q + U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [3]
          <>
            { pathLen < 4 ?
                      null
                    :
                      pathLen < 6 ?
                              <>{this.props.path[3]}/{this.props.path[4]}</>   // U/periodical
                            :
                              pathLen < 7 ?
                                      <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}</>   // U/periodical + T
                                    :
                                      pathLen < 8 ?
                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}</>    // U/periodical + T/T9
                                            :
                                              pathLen < 9 ?
                                                      <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}</> // U/periodical + T/T9 + T8
                                                    :
                                                      pathLen < 10 ?
                                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}</>   // T/periodical + T/T9 + T8 + T7
                                                            :
                                                              pathLen < 11 ?
                                                                      <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  // T/periodical + T9 + T8 + T7 + T6
                                                                    : //EXPANDED from here
                                                                      pathLen < 12 ?
                                                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  // T/periodical + T/T9 + T8 + T7 + T6 + T5
                                                                            :
                                                                              pathLen < 13 ?
                                                                                      <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // T/periodical + T/T9 + T8 + T7 + T6 + T5 + T4
                                                                                    :
                                                                                      pathLen < 14 ?
                                                                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // T/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3
                                                                                            :  // EXPAND below, from constant
                                                                                              pathLen < 15 ?
                                                                                                      <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                                                    :
                                                                                                      pathLen < 16 ?
                                                                                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                                            :
                                                                                                              <>{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // U/periodical + T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [4] not used
          <></>,
          // [5]
          <>
            {
              pathLen < 6 ?
                      null
                    :
                      pathLen < 8 ?
                              <>{this.props.path[5]}/{this.props.path[6]}</>    // /T/T9
                            :
                              pathLen < 9 ?
                                      <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}</> // /T/T8 + T7
                                    :
                                      pathLen < 10 ?
                                              <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}</>   // /T/T9 + T8 + T7
                                            :
                                              pathLen < 11 ?
                                                      <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  // /T/T9 + T8 + T7 + T6
                                                    : //EXPANDED from here
                                                      pathLen < 12 ?
                                                              <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  // /T/T9 + T8 + T7 + T6 + T5
                                                            :
                                                              pathLen < 13 ?
                                                                      <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // /T/T9 + T8 + T7 + T6 + T5 + T4
                                                                    :
                                                                      pathLen < 14 ?
                                                                              <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // /T/T9 + T8 + T7 + T6 + T5 + T4 + T3
                                                                            :  // EXPAND below, from constant
                                                                              pathLen < 15 ?
                                                                                      <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // /T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                                    :
                                                                                      pathLen < 16 ?
                                                                                              <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // /T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                            :
                                                                                              <>{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // /T/T9 + T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0

            }
          </>,
          // [6] not used
          <>
          </>,
          // [7]
          <>
            {
              pathLen < 8 ?
                      null
                    :
                      pathLen < 9 ?
                              <>{this.props.path[7]}</> // T8
                            :
                              pathLen < 10 ?
                                      <>{this.props.path[7]}/{this.props.path[8]}</>   // T8 + T7
                                    :
                                      pathLen < 11 ?
                                              <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}</>  // T8 + T7 + T6
                                            : //EXPANDED from here
                                              pathLen < 12 ?
                                                      <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  // T8 + T7 + T6 + T5
                                                    :
                                                      pathLen < 13 ?
                                                              <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // T8 + T7 + T6 + T5 + T4
                                                            :
                                                              pathLen < 14 ?
                                                                      <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // T8 + T7 + T6 + T5 + T4 + T3
                                                                    :  // EXPAND below, from constant
                                                                      pathLen < 15 ?
                                                                              <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // T8 + T7 + T6 + T5 + T4 + T3 + T2
                                                                            :
                                                                              pathLen < 16 ?
                                                                                      <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                                    :
                                                                                      <>{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T8 + T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [8]
          <>
            {
              pathLen < 9 ?
                      null
                    :
                      pathLen < 10 ?
                              <>{this.props.path[8]}</>   // T7
                            :
                              pathLen < 11 ?
                                      <>{this.props.path[8]}/{this.props.path[9]}</>  // T7 + T6
                                    : //EXPANDED from here
                                      pathLen < 12 ?
                                              <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}</>  // T7 + T6 + T5
                                            :
                                              pathLen < 13 ?
                                                      <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // T7 + T6 + T5 + T4
                                                    :
                                                      pathLen < 14 ?
                                                              <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // T7 + T6 + T5 + T4 + T3
                                                            :  // EXPAND below, from constant
                                                              pathLen < 15 ?
                                                                      <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // T7 + T6 + T5 + T4 + T3 + T2
                                                                    :
                                                                      pathLen < 16 ?
                                                                              <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T7 + T6 + T5 + T4 + T3 + T2 + T1
                                                                            :
                                                                              <>{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T7 + T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [9]
          <>
            {
              pathLen < 10 ?
                      null
                    :
                      pathLen < 11 ?
                              <>{this.props.path[9]}</>  // T6
                            : //EXPANDED from here
                              pathLen < 12 ?
                                      <>{this.props.path[9]}/{this.props.path[10]}</>  // T6 + T5
                                    :
                                      pathLen < 13 ?
                                              <>{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}</>  // T6 + T5 + T4
                                            :
                                              pathLen < 14 ?
                                                      <>{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // T6 + T5 + T4 + T3
                                                    :  // EXPAND below, from constant
                                                      pathLen < 15 ?
                                                              <>{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // T6 + T5 + T4 + T3 + T2
                                                            :
                                                              pathLen < 16 ?
                                                                      <>{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T6 + T5 + T4 + T3 + T2 + T1
                                                                    :
                                                                      <>{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T6 + T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          // [10]
          <>
            {
              pathLen < 11 ?
                      null
                    : //EXPANDED from here
                      pathLen < 12 ?
                              <>{this.props.path[10]}</>  // T5
                            :
                              pathLen < 13 ?
                                      <>{this.props.path[10]}/{this.props.path[11]}</>  // T5 + T4
                                    :
                                      pathLen < 14 ?
                                              <>{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}</>  // T5 + T4 + T3
                                            :  // EXPAND below, from constant
                                              pathLen < 15 ?
                                                      <>{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // T5 + T4 + T3 + T2
                                                    :
                                                      pathLen < 16 ?
                                                              <>{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T5 + T4 + T3 + T2 + T1
                                                            :
                                                              <>{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T5 + T4 + T3 + T2 + T1 + T0
            }
          </>,
          //[11] WAS not used.   NOW:  EXPANDED from here
          <>
            {
              pathLen < 12 ?
                      null
                    : //EXPANDED from here
                      pathLen < 13 ?
                              <>{this.props.path[11]}</>  // T4
                            :
                              pathLen < 14 ?
                                      <>{this.props.path[11]}/{this.props.path[12]}</>  // T4 + T3
                                    :  // EXPAND below, from constant
                                      pathLen < 15 ?
                                              <>{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}</>  // T4 + T3 + T2
                                            :
                                              pathLen < 16 ?
                                                      <>{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T4 + T3 + T2 + T1
                                                    :
                                                      <>{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T4 + T3 + T2 + T1 + T0
            }
          </>,
          //[12]
          <>
            {
              pathLen < 13 ?
                      null
                    : //EXPANDED from here
                      pathLen < 14 ?
                              <>{this.props.path[12]}</>  // T3
                            :  // EXPAND below, from constant
                              pathLen < 15 ?
                                      <>{this.props.path[12]}/{this.props.path[13]}</>  // T3 + T2
                                    :
                                      pathLen < 16 ?
                                              <>{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}</>  // T3 + T2 + T1
                                            :
                                              <>{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T3 + T2 + T1 + T0
            }
          </>,
          //[13]
          <>
            {
              pathLen < 14 ?
                      null
                    :  // EXPAND below, from constant
                      pathLen < 15 ?
                              <>{this.props.path[13]}</>  // T2
                            :
                              pathLen < 16 ?
                                      <>{this.props.path[13]}/{this.props.path[14]}</>  // T2 + T1
                                    :
                                      <>{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</>  // T2 + T1 + T0
            }
          </>,
          //[14] - NEW since expanding to 9-level transients
          <>
            {
              pathLen < 15 ?
                      null
                    :
                      pathLen < 16 ?
                              <>{this.props.path[14]}</>  // T1
                            :
                              <>{this.props.path[14]}/{this.props.path[15]}</>  // T1 + T0
            }
          </>,
          //[15] - NEW since expanding to 9-level transients
          <>
            {
              pathLen < 16 ?
                      null
                    :
                      <>{this.props.path[15]}</>  // T0
            }
          </>
      ],

      contentReady: false,
      txId: null,
      decodedTx: '',      // this will be an attempt at a decode INDEPENDENT of qFDTx() - STRINGIFIED
      contentInfo: null,
      content: null,

      isAGuestPost: false,  // This now gets set at conclusion of findThePost()

      contentPending: false,
      contentEncrypted: false,

      showQuickToast: false,
      toastText: '',
      toastDuration: 800,
      suppressLoader: false,
    };

    this.checkForPerms                  = this.checkForPerms.bind(this);
    this.toggleDbPerms                  = this.toggleDbPerms.bind(this);
    this.revokePermission               = this.revokePermission.bind(this);
    this.closeAreYouSureModal           = this.closeAreYouSureModal.bind(this);
    this.startTheSearch                 = this.startTheSearch.bind(this);
    this.findThePost                    = this.findThePost.bind(this);
    this.closeLoader                    = this.closeLoader.bind(this);

    this.explainMore                    = this.explainMore.bind(this);
    this.closeExplainMore               = this.closeExplainMore.bind(this);

    this.walkNameTreeWithoutDB          = this.walkNameTreeWithoutDB.bind(this);
    this.walkQuarterliesWithoutDB       = this.walkQuarterliesWithoutDB.bind(this);
    this.walkPeriodicalsWithoutDB       = this.walkPeriodicalsWithoutDB.bind(this);
    this.walkTransientsWithoutDB        = this.walkTransientsWithoutDB.bind(this);

    this.buildDecodedTx                 = this.buildDecodedTx.bind(this);

    this.shareLinkToPost                = this.shareLinkToPost.bind(this);
  }

  async componentDidMount() {
    console.warn("linkJumper: componentDidMount() props.path = " + this.props.path + " !!! <-----")
    console.warn("linkJumper: componentDidMount() props.rhs = " + this.props.rhs + " !!! <-----")


    const pathLen = this.props.path.length;
    console.warn("BTW: pathLen is " + pathLen)
    console.warn("this.state.deepestTLevel: " + this.state.deepestTLevel)

    // Check if the user already has a BitShizzle IDB setup
    // This would indicate he's already granted permission
    await this.checkForPerms()

    //NOTE: we kick-off the search from render()
  }

  //NOTE: this is copied from app's dbStuff()
  async checkForPerms() {

    const { dbExists, idbSupported } = await checkForIDBPerms();

    this.setState({dbPerms: dbExists, idbSupported: idbSupported})
  }

  toggleDbPerms() {
    if ( this.state.dbPerms ) {

      // don't IMMEDIATELY turn-off permissions
      this.setState({showAreYouSureModal: true})
    } else {
      this.setState({dbPerms: !this.state.dbPerms})
    }
  }
  revokePermission() {
    this.setState({dbPerms: false})
    this.closeAreYouSureModal()

    //FIXME: should DELETE the IDB
  }
  closeAreYouSureModal() {
    this.setState({showAreYouSureModal: false})
  }

  // extracted, simplified from buildShizzle's queryFetchDecodeTx()
  buildDecodedTx(rawOutputs, inputChunks, rawInputs) {

    const statei = new Array( rawOutputs.length )
    const numOutputs = rawOutputs.length
    const associatedInput = new Array( rawOutputs.length )

    // extract useful input parameters - part of what unlocks input 0
    // Based on the mode of OUTPUT 0 (which 'defines' the tx contract), we know what
    // input parameters to expect
    //NOTE: today, only Dialogs, Transients, Periodicals, quarterlies, and Appends have
    //      enhanced prevOut info embedded in their output state
    //      That is useful to deduce the associated input of any given output.
    let input3Params = null
    let input2Params = null
    let input1Params = null
    let input0Params
    //let input2Params = '';

    for ( let i = 0; i < numOutputs; i++ ) {
      const script = rawOutputs[i].script
      const outValue = Buffer.from(rawOutputs[i].value, 'hex').readUIntLE(0, 6)  //FIXME: should look at all 8 bytes

      // boring payout, or change?
      //WARNING: this logic must match a little bit below
      if ( script.length === 50 &&
          script.toUpperCase().startsWith("76A914") &&     // DUP, HASH160  PKHLen
          script.toUpperCase().endsWith("88AC")) {         // EQUALVERIFY, CHECKSIG
        // Payout or Change
        console.log(  "output #" + i + ":    script len: " + script.length
              + "    value: " + outValue )
        console.log("    FOR THE RECORD, here's the payout/change script: ", script)
        // Note that payouts and change are most likely ALWAYS exactly 50 bytes

        // this output is a CHANGE output, so, it has no EASILY-associated input
        associatedInput[i] = null

        // the remaining outputs are payouts, change (and/or EBFRA?)
        break;

      } else {
        console.warn("Preliminary decode of output " + i + " - to get its scripthash")
        // we now pass in the inputChunks for the 0th input - to potentially supply the
        // .specialOp input field for when decoding Continue (to maybe add a /voteN to the address)
        statei[i] = decodeScriptsToState(script, rawOutputs[i].value, true)

        //NOTE: this routine is also used by buildShizzle's qFDTx() - circa line 2620
        associateInputWithOutput(associatedInput, rawInputs, statei[i], i)
      }

    }

    const spawns      = numOutputs > 1 && statei[1] && statei[1].namePath === statei[0].namePath
    const guestIdx    = spawns ? 2 : 1
    const guestSpawns = numOutputs > 2 && statei[guestIdx + 1] && statei[guestIdx + 1].namePath === statei[guestIdx].namePath

    // We NEED an associated input for output 0. We can't proceed if there is none.
    if ( associatedInput[0] === null ) {
      console.error("LIBRARY CODE ERROR: There's no input associated with output 0. That can't be")
      alert("LIBRARY CODE ERROR: There's no input associated with output 0. That can't be")
      throw new Error("CODE ERROR: There's no input associated with output 0. That can't be")
    }

    const inputIdxForOutput0 = associatedInput[0]
    input0Params = getUsefulInputParams(inputChunks[inputIdxForOutput0]);
    statei[0].inputParams = input0Params
    if ( input0Params.hostGuestMode === 1 ) {
      input1Params = getUsefulInputParams(inputChunks[associatedInput[1]]);
      statei[1].inputParams = input1Params

      if ( spawns || guestSpawns ) {
        input2Params = getUsefulInputParams(inputChunks[associatedInput[2]])
        statei[2].inputParams = input2Params

        if ( spawns && guestSpawns ) {
          input3Params = getUsefulInputParams(inputChunks[associatedInput[3]])
          statei[3].inputParams = input3Params
        }
      }
    }

    const hasGuestPost = statei[0].inputParams.hostGuestMode === 1

    const shizzleAddress = statei[0].address
    const limb = statei[0].namePath ?
              hexStringToAscii( statei[0].namePath )
            :
              '';

    //FIXME: the end of qFDTx() checks for shizzleProfile info
    console.error("LinkJumper could, and probably should, check for shizzleProfile info along the way")

    const newDecodedTx = {
      //state: statei[0],		//redundant It's already contained in outputStates[0]
      outputStates:     statei,
      address:          shizzleAddress,
      //confirmedOutputs: confirmed,
      //bogusOutputs:     bogus,
      limbName:         limb,
      //buildable:        buildable,
      //followable:       followable,
      //unspendable:      unspendable,
      //foundBuildable:   foundBuildable,
      //foundFollowable:  foundFollowable,

      spawns:           spawns,
      hasGuestPost:     hasGuestPost,
      guestOutIdx:      guestIdx,
      guestSpawns:      guestSpawns,

      associatedInput:  associatedInput,

      input0Params:     input0Params,			// content, txid, pcode  (for tx, and hostTx)
      //input0PrevTxId:   prev0TxId,
      //input1PrevTxId:   prev1TxId,			// might only be useful for guest posts (Transients only)
      input1Params:     input1Params,			// in host/guest mode, this would be the guest's input params
      input2Params:     input2Params,
      input3Params:     input3Params,

      //input2Params:     input2Params,   *****
      //dialogNamePath:   dialogNamePath,       // carried-forward
                          // TODO: carry-forward most-recent owner PKey, guest PK, and OUR p2pkh priv
      //dialogSentBy:     dialogSentBy,
      //fundingPK:        fundingPK,    ***** // currently copied from input2Params.fundingPubKey
      //dialogMostRecentOwnerPubKey:    dialogMostRecentOwnerPubKey,
      //dialogMostRecentVisitorPubKey: dialogMostRecentVisitorPubKey,
      //rawOutputs: rawOutpushzlProfilets	*****			// has both the .scripts, and .values

      //shzlProfile:      shzlProfile,  *****
    }

    return newDecodedTx
  }

  async walkNameTreeWithoutDB(startingTxId, destDomain) {

    console.warn("destination domain: ", destDomain)

    let queryFailed = false
    let trailEndsPrematurely = false

    let currentDomain = ''
    let domainStillShort = true

    let currentTxId = startingTxId
    let prevTxId = null
    let finalMode = ''
    let outputIsAppend = true
    let numDecompositionAttempts = 0
    do {
      let i = currentDomain.length
      const maybeAddOneToOutIdx = i > 0 ? 1 : 0

      const rawTx = await getRawInfo(currentTxId, getProviderContext(window.shizzleContext));

      if ( rawTx === null || typeof rawTx === 'number' ) {
        // we return more than null - the response status code, if present
        //FIXME: WHY did we fail? If 404, AND the DB has record of it, then maybe we need
        //       to delete the record, AND its children (recursively).
        //       At the very least, we should take note of a 404 (schedule for investigation, or deletion)
        console.error("walkNameTreeWithoutDB(): failed getting raw tx info: " + rawTx)

        if ( rawTx === 404 ) {
          console.warn("walkNameTreeWithoutDB(): traditionally would have removed 'faded' tx: " + currentTxId);
          alert("We think there's something wrong with the link you're using.")
        } else {
          alert("ERROR: there's something wrong with the link you've provided")
        }

        queryFailed = true
        break;
      }

      // parse it, to get the state
      const decomposition = decomposeRawTx(rawTx, false, true)
      if ( decomposition.incompleteRawData ) {
        await mySleep(400 + 75 * numDecompositionAttempts, "wNTWDB(): Sleep before re-attempting the query for tx hex again ")
        ++numDecompositionAttempts
        continue
      }
      let rawOutputs = decomposition.outputs
      let rawInputs = decomposition.inputs

      const inputChunks = parseInputs(rawInputs, true)

      console.warn("linkJumper: wNTWDB(): there are " + rawInputs.length + " inputs")
      console.warn("linkJumper: wNTWDB(): there are " + rawOutputs.length + " outputs")

      let nextOutIdx
      let nextDomainChar = ''
      if ( domainStillShort ) {
        nextDomainChar = destDomain[i]
        console.warn("nextDomainChar: ", nextDomainChar)

        // Feedback/progress: update user on which char is being sought
        this.setState({ domainLHS: currentDomain,
                        domainCharBeingSought: nextDomainChar,
                        domainRHS: this.props.path[0].slice(i+1, this.props.path[0].length)})

        // choose output based on which letter/char we're looking for now
        nextOutIdx = nextDomainChar.charCodeAt(0) - 'a'.charCodeAt(0) + maybeAddOneToOutIdx
      } else {
        console.warn("NOW: looking immediately at output 0 of this tx")
        nextOutIdx = 0
      }

      console.warn("  nextOutIdx: ", nextOutIdx)

      const nextOutScript = rawOutputs[nextOutIdx].script

      //NOTE: we NO LONGER decode input param 'specialOp'
      const outputState = decodeScriptsToState(nextOutScript, rawOutputs[i].value, true)
      console.warn("state: ", outputState)

      const nextPath = outputState.namePath
      console.warn("nextPath: ", nextPath + ", or " + hexStringToAscii( nextPath ))

      currentDomain = currentDomain + nextDomainChar

      console.warn("currentDomain is now: ", currentDomain)

      console.warn("SCRIPT HASH (of this output): ", outputState.scriptHash)


      await mySleep(50, 'walkNameTreeWithoutDB() quick sleep before finding next tx')

      const nextTxId = await findNextTxFromProvider( getProviderContext(window.shizzleContext), outputState, currentTxId );
      console.warn("Next txId: ", nextTxId)

      // if there is no NEXT, we should recognize, and break")
      trailEndsPrematurely = nextTxId === null


//FIXME: use LENGTHS, not strings (just in case)
      domainStillShort = currentDomain !== destDomain


      finalMode = hexByteToAscii(outputState.mode)
      prevTxId = currentTxId
      currentTxId = nextTxId

      if ( !domainStillShort ) {
        if ( finalMode === 'X' ) {
          console.warn("We've found the domain, but it's mode is X - so, next tx is still APPEND, and we'll want output 0.\n\nIOW: ONE MORE TIME ")
          outputIsAppend = true
        } else if ( finalMode === 'K' ) {
          console.warn("ownerCount:", outputState.ownerCount, " We've found the domain, but it's mode is K - so, PRE-CLAIMED: THIS output state is Quarterly")
          outputIsAppend = false
        } else if ( finalMode === 'P' ) {
          console.warn("ownerCount:", outputState.ownerCount, " We've found the domain, but it's mode is P - so, CLAIMABLE: THIS output state is (SHORTENED?) Quarterly")
          outputIsAppend = false
        } else {
          alert("VERY WRONG. ERROR. Unexpected/invalid mode: ", finalMode)
          throw new Error("Problem with contract code?!")
        }
      }

      console.warn("current output address: ", outputState.address)
      console.warn("================ tree iteration ================")

    } while ( !queryFailed && !trailEndsPrematurely && (domainStillShort || outputIsAppend) );

    console.warn("DONE walking")
    console.log("trailEndsPrematurely: ", trailEndsPrematurely)
    console.log("queryFailed: ", queryFailed + "\n")

    console.log("finalMode - of CURRENT state: ", finalMode )
    console.log("outputIsAppend: ", outputIsAppend)
    console.log("current txId: ", prevTxId)
    console.log("next txId: ", currentTxId)

    if ( ! queryFailed && !trailEndsPrematurely ) {
      console.warn("End of nameTree. AFTER making sure we've got the correct OWNER COUNT, we'll need to follow the path on this domain now")
    } else if ( trailEndsPrematurely ) {
      alert("It appears that the trail ends prematurely. There may be something wrong with the link you were given")
    } else {
      alert("Something went wrong. We should determine if it's a problem with the provider, or with the link you were given.")
    }

    return {
        success: !queryFailed && !trailEndsPrematurely,
        nextTx: currentTxId
    }
  }

  async walkQuarterliesWithoutDB(startingTxId, path) {

    console.warn("looking for ownerCount of " + parseInt(path[1], 10) )
    console.warn("looking for quarterlyCount of " + parseInt(path[2], 10) )

    const destOwnerCount = parseInt(path[1], 10)
    if ( destOwnerCount < 1 || 255 < destOwnerCount ) {
      alert("malformed path. destination ownerCount: ", destOwnerCount)
      return { success: false, fullyDone: false, currentTx: startingTxId, nextTx: null }
    }

    const destQuarterlyCount = parseInt(path[2], 10)
    if ( destQuarterlyCount < 0 || 2000 < destOwnerCount ) {   //FIXME: shouldn't have an upper bound.
                                                                //FIXME: NOT SURE of the lower bound. 0 okay?
      alert("malformed path. destination QUARTERLYCount: ",  destQuarterlyCount)
      return { success: false, fullyDone: false, currentTx: startingTxId, nextTx: null }
    }

    let queryFailed = false
    let trailEndsPrematurely = false

    let fullyDone = false // we would set to true if we're NOT looking beyond quarterlies

    let ownerCountStillShort = true
    let quarterlyCountStillShort = false
    let currentTxId = startingTxId
    let prevTxId = null
    let contentInfo = null
    let decodedTx = null
    let numDecompositionAttempts = 0
    do {
      const rawTx = await getRawInfo(currentTxId, getProviderContext(window.shizzleContext));

      if ( rawTx === null || typeof rawTx === 'number' ) {
        // we return more than null - the response status code, if present
        //FIXME: WHY did we fail? If 404, AND the DB has record of it, then maybe we need
        //       to delete the record, AND its children (recursively).
        //       At the very least, we should take note of a 404 (schedule for investigation, or deletion)
        console.error("walkQuarterliesWithoutDB(): failed getting raw tx info: " + rawTx)

        if ( rawTx === 404 ) {
          console.warn("walkQuarterliesWithoutDB(): traditionally would have removed 'faded' tx: " + currentTxId);
          alert("We think there's something wrong with the link you're using.")
        } else {
          alert("ERROR: there's something wrong with the link you've provided")
        }

        queryFailed = true
        break;
      }

      // parse it, to get the state
      const decomposition = decomposeRawTx(rawTx, false, true)
      if ( decomposition.incompleteRawData ) {
        await mySleep(400 + 75 * numDecompositionAttempts, "wQWDB(): Sleep before re-attempting the query for tx hex again ")
        ++numDecompositionAttempts
        continue
      }
      const rawOutputs = decomposition.outputs
      const rawInputs = decomposition.inputs

      const inputChunks = parseInputs(rawInputs, true)

      console.warn("We're analyzing current txId ", currentTxId)
      console.warn("linkJumper: wQWDB(): there are " + rawInputs.length + " inputs")
      console.warn("linkJumper: wQWDB(): there are " + rawOutputs.length + " outputs")

      const out0Script = rawOutputs[0].script
      const out0State = decodeScriptsToState(out0Script, rawOutputs[0].value, true)

      console.warn("output0 state: ", out0State)
      console.warn("ownerCount: ", out0State.ownerCount)
      console.warn("QUARTERLYCount: ", out0State.quarterlyCount)


      await mySleep(50, 'walkQuarterliesWithoutDB() quick sleep before finding next tx')


      ownerCountStillShort = out0State.ownerCount < destOwnerCount
      if ( !ownerCountStillShort ) {

        this.setState({phase: 3})

        // FINALLY calculate the quarterlyCount
        quarterlyCountStillShort = out0State.quarterlyCount < destQuarterlyCount

        console.warn("QCStill short: ", quarterlyCountStillShort)
      }

      let stateToUse = out0State
      if ( !ownerCountStillShort && !quarterlyCountStillShort ) {


        console.warn("we've reached the correct owner and quarter. Should now MAYBE look at output 1 (base-0)")

        decodedTx = this.buildDecodedTx(rawOutputs, inputChunks, rawInputs)

        if ( path[3] && path[3] === 'U' ) {
          const out1Script = rawOutputs[1].script
          const out1State = decodeScriptsToState(out1Script, rawOutputs[1].value, true)
          stateToUse = out1State

          console.warn("BTW: output1 state: ", out1State)
          console.warn("We've been asked to look at periodicals. Must proceed further - using output 1 !!!! (see console)")
        } else {
          console.warn("We have NOT been asked to go further. We will FULLY stop here")
          //alert("We have NOT been asked to go further. We will FULLY stop here")
          fullyDone = true

          const inputIdxForOutput0 = decodedTx.associatedInput[0]
          const inputParams = getUsefulInputParams(inputChunks[ inputIdxForOutput0 ]);

          contentInfo = {inputParams: inputParams, decomposition: decomposition, inputChunks: inputChunks}
        }

        //decodedTx = this.buildDecodedTx(rawOutputs, inputChunks, rawInputs)
      }

      await mySleep(50, 'walkQuarterliesWithoutDB() quick sleep before finding next tx')

      const nextTxId = await findNextTxFromProvider( getProviderContext(window.shizzleContext), stateToUse, currentTxId );
      console.warn("Next txId: ", nextTxId)
      prevTxId = currentTxId
      currentTxId = nextTxId

      // if there is no NEXT, we should recognize, and break")
      trailEndsPrematurely = !fullyDone && nextTxId === null

      console.warn("current output address: ", stateToUse.address) //out0State.address)
      console.warn("================ Q iteration ================")

    } while ( !queryFailed && !trailEndsPrematurely && (ownerCountStillShort || quarterlyCountStillShort) );

    console.warn("DONE walking the QUARTERLIES")
    console.log("trailEndsPrematurely: ", trailEndsPrematurely)
    console.log("queryFailed: ", queryFailed + "\n")

    console.log("fullyDone: ", fullyDone + "\n")

    console.log("current txId: ", prevTxId)
    console.log("next txId: ", currentTxId)

    return {
      success: !queryFailed && !trailEndsPrematurely,
      fullyDone: fullyDone,

      currentTx: prevTxId,
      nextTx: currentTxId,

      contentInfo: contentInfo,
      dtx:    decodedTx,
    }
  }

  async walkPeriodicalsWithoutDB(startingTxId, path) {

    console.warn("looking for periodicCount of " + parseInt(path[4], 10) )

    const destPeriodicCount = parseInt(path[4], 10)
    if ( destPeriodicCount < 1 || 1000 < destPeriodicCount ) {
      alert("malformed path. destination PERIODIC count: ",  destPeriodicCount)
      alert("ALSO: fill-out the return value more")
      return { success: false, nextTx: null }
    }


    let queryFailed = false
    let trailEndsPrematurely = false

    let fullyDone = false // we would set to true if we're NOT looking beyond periodicals

    let periodicCountStillShort = true
    let currentTxId = startingTxId
    let prevTxId = null
    let contentInfo = null
    let decodedTx = null
    let numDecompositionAttempts = 0
    do {
      const rawTx = await getRawInfo(currentTxId, getProviderContext(window.shizzleContext));

      if ( rawTx === null || typeof rawTx === 'number' ) {
        // we return more than null - the response status code, if present
        //FIXME: WHY did we fail? If 404, AND the DB has record of it, then maybe we need
        //       to delete the record, AND its children (recursively).
        //       At the very least, we should take note of a 404 (schedule for investigation, or deletion)
        console.error("walkPeriodicalsWithoutDB(): failed getting raw tx info: " + rawTx)

        if ( rawTx === 404 ) {
          console.warn("walkPeriodicalsWithoutDB(): traditionally would have removed 'faded' tx: " + currentTxId);
          alert("We think there's something wrong with the link you're using.")
        } else {
          alert("ERROR: there's something wrong with the link you've provided")
        }

        queryFailed = true
        break;
      }

      // parse it, to get the state
      const decomposition = decomposeRawTx(rawTx, false, true)
      if ( decomposition.incompleteRawData ) {
        await mySleep(400 + 75 * numDecompositionAttempts, "wPWDB(): Sleep before re-attempting the query for tx hex again ")
        ++numDecompositionAttempts
        continue
      }
      const rawOutputs = decomposition.outputs
      const rawInputs = decomposition.inputs

      const inputChunks = parseInputs(rawInputs, true)

      console.warn("We're analyzing current txId ", currentTxId)
      console.warn("linkJumper: wPWDB(): there are " + rawInputs.length + " inputs")
      console.warn("linkJumper: wPWDB(): there are " + rawOutputs.length + " outputs")

      const out0Script = rawOutputs[0].script
      const out0State = decodeScriptsToState(out0Script, rawOutputs[0].value, true)

      console.warn("output0 state: ", out0State)
      console.warn("PERIODICCount: ", out0State.periodicCount)


      await mySleep(50, 'walkPeriodicalsWithoutDB() quick sleep before finding next tx')


      periodicCountStillShort = out0State.periodicCount < destPeriodicCount

      let stateToUse = out0State


      if ( !periodicCountStillShort ) {


        console.warn("we've reached the correct period. Should now MAYBE look at output 1 (base-0) (Transients)")

        decodedTx = this.buildDecodedTx(rawOutputs, inputChunks, rawInputs)

        if ( path[5] && path[5].length > 0 ) {
          console.warn("BTW: path[5]: ", path[5])
          const out1Script = rawOutputs[1].script
          const out1State = decodeScriptsToState(out1Script, rawOutputs[1].value, true)
          stateToUse = out1State

          console.warn("BTW: output1 state: ", out1State)
          console.warn("     path[6] (how far on T-level 9): ", path[6])
          console.warn("We've been asked to look at TRANSIENTS. Must proceed further - using output 1 !!!! (see console). BTW: current txId is " + currentTxId)
          //alert("We've been asked to look at TRANSIENTS. Must proceed further - using output 1 !!!! (see console). BTW: current txId is " + currentTxId)
        } else {
          console.warn("We have NOT been asked to go further, into transients. We will FULLY stop here.")
          //alert("We have NOT been asked to go further, into transients. We will FULLY stop here.")
          fullyDone = true

          const inputIdxForOutput0 = decodedTx.associatedInput[0]
          const inputParams = getUsefulInputParams(inputChunks[ inputIdxForOutput0 ]);

          contentInfo = {inputParams: inputParams, decomposition: decomposition, inputChunks: inputChunks}
        }

        //decodedTx = this.buildDecodedTx(rawOutputs, inputChunks, rawInputs)
      }

      await mySleep(50, 'walkPeriodicalsWithoutDB() quick sleep before finding next tx')

//FIXME: if we're at the right count, we should look at out1 for the NEXT tx
      const nextTxId = await findNextTxFromProvider( getProviderContext(window.shizzleContext), stateToUse, currentTxId );
      console.warn("Next txId: ", nextTxId)
      prevTxId = currentTxId
      currentTxId = nextTxId


      // if there is no NEXT, we should recognize, and break")
      trailEndsPrematurely = !fullyDone && nextTxId === null

      console.warn("current output address: ", stateToUse.address) //out0State.address)
      console.warn("================ Periodical iteration ================")

    } while ( !queryFailed && !trailEndsPrematurely && periodicCountStillShort );

    console.warn("DONE walking the PERIODICALS")
    console.log("trailEndsPrematurely: ", trailEndsPrematurely)
    console.log("queryFailed: ", queryFailed + "\n")

    console.log("fullyDone: ", fullyDone + "\n")

    console.log("current txId: ", prevTxId)
    console.log("next txId: ", currentTxId)

    return {
      success: !queryFailed && !trailEndsPrematurely,
      fullyDone: fullyDone,

      currentTx: prevTxId,
      nextTx: currentTxId,

      contentInfo: contentInfo,
      dtx:    decodedTx,
    }

  }

  async walkTransientsWithoutDB(startingTxId, path, level, tLevel, finalLevel ) {
    const ourDomain = path[0]
    console.warn("WALK TRANSIENTS. Following ('our') domain of " + ourDomain + ", and CURRENT level (of path array) is " + level)
    console.warn("Path: ", path)
    console.warn("T-Level: ", tLevel)
    console.warn("deepestTLevel: " + this.state.deepestTLevel)
    console.log("finalLevel: " + finalLevel)

    console.warn("Walk TRANSIENTS. Following OUR domain of '" + ourDomain + "', and CURRENT level (of path array) is " + level + ". STARTING at txId " + startingTxId)
    //alert("Walk TRANSIENTS. Following 'OUR' domain of " + ourDomain + ", and CURRENT level (of path array) is " + level + ". STARTING at txId " + startingTxId)
    console.warn("walkTransients: final level ? " + (finalLevel ? 'true' : 'false') )
    //alert("walkTransients: final level ? " + (finalLevel ? 'true' : 'false'))

    const destUpCount = parseInt(path[level], 10)
    console.warn("\n\nwTWDb(): top of func. path: " + path + "   level: " + level + "   tLevel: " + tLevel + "   finalLevel: " + finalLevel + "   destUpCount: " + destUpCount)

    if ( destUpCount === NaN ) {
      alert("ERROR: we need to implement code for jumping to guest posts - or something else.")
      return
    }
    if ( destUpCount < 0 || 255 < destUpCount ) {
      alert("malformed path. destination up count: ",  destUpCount)
      alert("IMPLEMENT ME: fill-out the return value more")
      return { success: false, nextTx: null }
    }

    console.warn("At THIS transient level (" + tLevel + "), we're looking for an upCount of " + destUpCount + ". We're starting at txId " + startingTxId)

    let queryFailed = false
    let trailEndsPrematurely = false

    // ??? maybe not usefule for transients
    let fullyDone = false // we would set to true if we're NOT looking beyond this Transient level ?

    let upCountStillShort = true

    let currentTxId = startingTxId
    let prevTxId = null
    let contentInfo = null
    let inputParams
    let inputChunks
    let decomposition
    let decodedTx = null
    let thisIsAGuestPost = false
    let numDecompositionAttempts = 0

    do {
      const rawTx = await getRawInfo(currentTxId, getProviderContext(window.shizzleContext));

      if ( rawTx === null || typeof rawTx === 'number' ) {
        // we return more than null - the response status code, if present
        //FIXME: WHY did we fail? If 404, AND the DB has record of it, then maybe we need
        //       to delete the record, AND its children (recursively).
        //       At the very least, we should take note of a 404 (schedule for investigation, or deletion)
        console.error("walkTransientsWithoutDB(): failed getting raw tx info: " + rawTx)

        if ( rawTx === 404 ) {
          console.warn("walkTransientsWithoutDB(): traditionally would have removed 'faded' tx: " + currentTxId);
          alert("We think there's something wrong with the link you're using.")
        } else {
          alert("ERROR: there's something wrong with the link you've provided")
        }

        queryFailed = true
        break;
      }

      // parse it, to get the state
      decomposition = decomposeRawTx(rawTx, false, true)
      if ( decomposition.incompleteRawData ) {
        await mySleep(400 + 75 * numDecompositionAttempts, "wTWDB(): Sleep before re-attempting the query for tx hex again ")
        ++numDecompositionAttempts
        continue
      }
      const rawOutputs = decomposition.outputs
      const rawInputs = decomposition.inputs

      inputChunks = parseInputs(rawInputs, true)

      console.warn("We're analyzing current txId ", currentTxId)
      console.log("linkJumper: wTWDB(): there are " + rawInputs.length + " inputs")
      console.log("linkJumper: wTWDB(): there are " + rawOutputs.length + " outputs")

      decodedTx = this.buildDecodedTx(rawOutputs, inputChunks, rawInputs)

      // Which output state should we use to know the current downCounter?
      // By default, we assume the 0th output - for self-posts
      let stateToUse = decodedTx.outputStates[0]

      // Which output # (base-0) to use IF we need to go to the NEXT (deeper) level
      // If a self-post, the next level is via the sub-spawn Transient
      // NOTE: ONLY used if we've reached the proper downCounter on this level
      let outputIdxLeadingToNextLevelDown = 1

      let weAreGuestPosting = false
      let weAreHosting = false
      let guestIdx

      console.warn("BTW: rawOutputs: ", rawOutputs)
      console.warn("BTW: .outputStats[]", decodedTx.outputStates)

      //NOTE: we can't assume there's always a change output (in future)
      //NOTE: we can't assume there are spawns just because there COULD be spawns
      // And always remember there could be a guest, OR, we could be a guest

      if ( rawOutputs.length === 1 || rawOutputs.length > 1 && rawOutputs[1].script.length < 200 ) {
        console.warn("There's only ONE output ! So, we must be posting. So what? No need to stop here.")

      } else {
        console.warn("There are MORE than 1 output? " + rawOutputs.length)

        if ( hexStringToAscii(decodedTx.outputStates[0].namePath) !== ourDomain ) {

          console.warn("0th output name not ours. Hence, we are making a GuestPost at domain " + hexStringToAscii(decodedTx.outputStates[0].namePath))

          weAreGuestPosting = true

          guestIdx = decodedTx.guestOutIdx

          stateToUse = decodedTx.outputStates[ guestIdx ]

          //NEW: hosts can now spawn, so, we still need to determine WHICH output starts the guest-poster
          outputIdxLeadingToNextLevelDown = guestIdx + 1

          console.warn("We are guest-posting, BUT, state to use NEXT might be NEXT output (indexOfNextOutput " + outputIdxLeadingToNextLevelDown + " - if we've reached dest upCount)")
        } else {
          // we're NOT guest-posting, so, we know what we need

          stateToUse = decodedTx.outputStates[ 0 ]
          outputIdxLeadingToNextLevelDown = 1

console.warn("state to use: ", stateToUse)

          // We are NOT guest-posting. But maybe we're HOSTING?
          weAreHosting = decodedTx.input0Params.hostGuestMode === 1
          console.warn("We are hosting? " + weAreHosting ? 'true' : 'false')
        }
      }

      const maxDownCounterInt = parseInt( stateToUse.maxDownCounterHex, 16 )
      console.log("HEX of max downCounter int: ", stateToUse.maxDownCounterHex)
      console.log("MAX downCounter int: ", maxDownCounterInt)
      console.warn("downCount: ", stateToUse.downCounterInt)
      const upCounterInt = maxDownCounterInt - stateToUse.downCounterInt
      console.warn("upCount: ", upCounterInt)
      console.log("destUpCount: ", destUpCount, "   <-- and this")

      //Have we traveled far enough on this T-level?
      upCountStillShort = upCounterInt < destUpCount

      // we need to choose the correct NEXT state to use
      // IF this is a guest-post, it could be output #2 (base-0)
      if ( !upCountStillShort ) {
        console.warn("we've reached the correct upCount (in the OUTPUT). Should now MAYBE look at output " + outputIdxLeadingToNextLevelDown + " (base-0)")

        if ( !finalLevel ) {
          console.warn("Since the up-count is no-longer short (in the output state), AND it's NOT the final level, we'll be looking at output #" + outputIdxLeadingToNextLevelDown + " (base-0) of the current tx: " + currentTxId)

          stateToUse = decodedTx.outputStates[outputIdxLeadingToNextLevelDown]

          console.warn("BTW: stateToUse (to find next level down): ", stateToUse)
          console.log("   and address of that out: ", stateToUse.address)
          console.warn("We've been asked to look at deeper transients. Must proceed further - using base-0 output #" + outputIdxLeadingToNextLevelDown )

        } else {
          console.warn("ACTUALLY, we have NOT been asked to go to deeper transients. We will FULLY stop here\n\nWill use content from the proper output")

          fullyDone = true

          thisIsAGuestPost = weAreGuestPosting || weAreHosting

          const idxToUse =  weAreGuestPosting ? guestIdx : 0
          inputParams = idxToUse === 0 ?
                                  decodedTx.input0Params
                                :
                                  idxToUse === 1 ?
                                            decodedTx.input1Params
                                          :
                                            decodedTx.input2Params

          console.log("wTWDB(): in looking at input params will use idx " + idxToUse)
          console.warn("   inputParam: ", inputParams)

          //FIXME: will we really need anything more than just inputParams? If so, document/mention why
          //BTW: we could figure-out which inputParms to use later,
          // but, maybe it's nice to have this nicely-packaged for us? hmm
          contentInfo = {inputParams: inputParams, decomposition: decomposition, inputChunks: inputChunks, idxToUse: idxToUse, guestPosting: weAreGuestPosting, hosting: weAreHosting}
        }
      }

      // if fullyDone, prob no need sleep, nor to findNextTxFromProvider()
      //  * UNLESS *  we wanted to find-out the nextTxId for some reason
      if ( fullyDone ) {
        trailEndsPrematurely = false
      } else {
        await mySleep(150, 'walkTransientsWithoutDB() quick sleep - before finding next tx')

        const nextTxId = await findNextTxFromProvider( getProviderContext(window.shizzleContext), stateToUse, currentTxId );
        console.warn("Next txId: ", nextTxId)
        prevTxId = currentTxId
        currentTxId = nextTxId

        // if there is no NEXT, we should recognize, and break")
        trailEndsPrematurely = !fullyDone && nextTxId === null
      }

      console.warn("current output address: ", stateToUse.address) //out0State.address)
      console.warn("================ Transient iteration ================")

    } while ( !queryFailed && !trailEndsPrematurely && upCountStillShort );


    console.warn("DONE walking THIS Transient level")
    console.log("trailEndsPrematurely: ", trailEndsPrematurely)
    console.log("queryFailed: ", queryFailed + "\n")

    console.log("fullyDone: ", fullyDone + "\n")

    console.log("current txId: ", prevTxId)
    console.log("next txId: ", currentTxId)

    if ( fullyDone ) {
      console.warn("NOTE: since we're fullyDone for transients, we won't look at NEXT tx, we need to look at content info (input params) of CURRENT tx: ", prevTxId )
      //alert("NOTE: since we're fullyDone for transients, we won't look at NEXT tx, we need to look at content (input params) of CURRENT tx")
    } else {
      console.warn("We're done with this transient level " + tLevel + ", but not FULLY done. We'll now look deeper, at next txId: " + currentTxId)
      //alert("We're done with this transient level " + tLevel + ", but not FULLY done. We'll now look deeper, at next txId: " + currentTxId)
    }

    return {
      success: !queryFailed && !trailEndsPrematurely,
      fullyDone: fullyDone,

      currentTx: prevTxId,
      nextTx: currentTxId,       //not filled/correct if fullyDonw

      contentInfo: contentInfo,
      dtx:    decodedTx,

      isAGuestPost: thisIsAGuestPost
    }
  }

  // kick-off the search - asynchronously
  startTheSearch() {
    console.warn("startTheSearch()  props.path: ", this.props.path)
    console.warn("startTheSearch()  props.rhs: ",  this.props.rhs)

    // really, state.searchStarted takes too long to ripple
    this.searchStarted = true

    const self = this
    execAsync( async function() {
      self.setState({searchStarted: true},
                    async () => {
                      const {success, content, txId, dtx, isAGuestPost} = await self.findThePost( self.props.path )

                      if ( success ) {
                          self.setState({contentPending: true, contentReady: true, content: content, txId: txId},
                              async function() {
                                  const {dtxString, contentEncrypted} = await maybeDecryptContent( dtx, self.props.getKeyForDecryption )

                                  self.setState({ decodedTx: dtxString,
                                                  contentPending: false,
                                                  isAGuestPost: isAGuestPost })
                              }
                          );
                      } else {
                        alert("LinkJumper: SOMETHING WENT WRONG")
                      }
                    }
                  );
    }, 10);
  }

  // Initial logic will AVOID IDB entirely - to simulate experience of a NEWBIE
  async findThePost(path) {

    console.warn("findThePost(): path: ", path)
    console.warn("findThePost()... starting with genesis tx: ", GENESIS_APPEND)

    this.setState({phase: 1})

    const {success, nextTx} = await this.walkNameTreeWithoutDB(GENESIS_APPEND, path[0])
    //random mainnet tx (will fail testnet query): 40ff70b97334699d71a552ab5ea97c996fa8d64a9e0dc0041ec1701b10ed6914
    //const {success, nextTx} = await this.walkNameTreeWithoutDB("40ff70b97334699d71a552ab5ea97c996fa8d64a9e0dc0041ec1701b10ed6914", path[0])

    if ( !success ) {
      alert("oh well :(   Failed to find the domain")
      return {success: false}
    }

    this.setState({phase: 2})

    console.warn("NOW, we must walk the quarterlies...")
    const {success: success2, fullyDone, currentTx: currentTx2, nextTx: nextTx2, contentInfo: contentInfo, dtx: decodedTx2} = await this.walkQuarterliesWithoutDB(nextTx, path)

    if (!success2) {
      alert("oh well :(  Failed to find the owner and/or quarterly")
      return {success: false}
    }

    if ( fullyDone ) {
      console.warn("BTW: contentInfo: ", contentInfo)
      return {success: true, content: contentInfo.inputParams.content, txId: currentTx2, dtx: decodedTx2, isAGuestPost: false }
    }

    this.setState({phase: 4})

    console.warn("GREAT so far. About to walk the periodicals (much like quarterlies)...")
    const {success: success3, fullyDone: fullyDone3, currentTx: currentTx3, nextTx: nextTx3, contentInfo: contentInfo3, dtx: decodedTx3} = await this.walkPeriodicalsWithoutDB(nextTx2, path)

    if (!success3) {
      alert("oh well :(  Failed to find the periodical")
      return {success: false}
    }

    if ( fullyDone3 ) {
      console.warn("BTW: contentInfo3: ", contentInfo3)
      return {success: true, content: contentInfo3.inputParams.content, txId: currentTx3, dtx: decodedTx3, isAGuestPost: false }
    }

    this.setState({phase: 5})

    console.warn("Deepest T level: " + this.state.deepestTLevel)

    //T7
    console.warn("GREAT3 so far. Next, walk the ZIG-ZAGGING transients of level 9. Will look at tx " + nextTx3)
    const {success: success4, fullyDone: fullyDone4, currentTx: currentTx4, nextTx: nextTx4, contentInfo: contentInfo4, dtx: decodedTx4, isAGuestPost: isAGuestPost4} = await this.walkTransientsWithoutDB(nextTx3, path, 6, 9, 9 === this.state.deepestTLevel)

    if (!success4) {
      alert("oh well :(  Failed to find the T9")
      return {success: false}
    }

    if ( fullyDone4 ) {
      console.warn("BTW: contentInfo4: ", contentInfo4)
      return {success: true, content: contentInfo4.inputParams.content, txId: currentTx4, dtx: decodedTx4, isAGuestPost: isAGuestPost4 }
    }

    this.setState({phase: 6})

    //T6
    console.warn("GREAT4 so far. Next, walk the ZIG-ZAGGING transients of level 8. Will look at tx " + nextTx4)
    const {success: success5, fullyDone: fullyDone5, currentTx: currentTx5, nextTx: nextTx5, contentInfo: contentInfo5, dtx: decodedTx5, isAGuestPost: isAGuestPost5} = await this.walkTransientsWithoutDB(nextTx4, path, 7, 8, 8 === this.state.deepestTLevel)

    if (!success5) {
      alert("oh well :(  Failed to find the T8")
      return {success: false}
    }

    if ( fullyDone5 ) {
      console.warn("BTW: contentInfo5: ", contentInfo5)
      return {success: true, content: contentInfo5.inputParams.content, txId: currentTx5, dtx: decodedTx5, isAGuestPost: isAGuestPost5 }
    }

    this.setState({phase: 7})

    //T5
    console.warn("GREAT5 so far. Next, walk the ZIG-ZAGGING transients of level 7. Will look at tx " + nextTx5)
    const {success: success6, fullyDone: fullyDone6, currentTx: currentTx6, nextTx: nextTx6, contentInfo: contentInfo6, dtx: decodedTx6, isAGuestPost: isAGuestPost6} = await this.walkTransientsWithoutDB(nextTx5, path, 8, 7, 7 === this.state.deepestTLevel)

    if (!success6) {
      alert("oh well :(  Failed to find the T7")
      return {success: false}
    }

    if ( fullyDone6 ) {
      console.warn("BTW: contentInfo6: ", contentInfo6)
      return {success: true, content: contentInfo6.inputParams.content, txId: currentTx6, dtx: decodedTx6, isAGuestPost: isAGuestPost6 }
    }

    this.setState({phase: 8})

    //T4
    console.warn("GREAT6 so far. Next, walk the ZIG-ZAGGING transients of level 6. Will look at tx " + nextTx6)
    const {success: success7, fullyDone: fullyDone7, currentTx: currentTx7, nextTx: nextTx7, contentInfo: contentInfo7, dtx: decodedTx7, isAGuestPost: isAGuestPost7} = await this.walkTransientsWithoutDB(nextTx6, path, 9, 6, 6 === this.state.deepestTLevel)

    if (!success7) {
      alert("oh well :(  Failed to find the T6")
      return {success: false}
    }

    if ( fullyDone7 ) {
      console.warn("BTW: contentInfo7: ", contentInfo7)
      return {success: true, content: contentInfo7.inputParams.content, txId: currentTx7, dtx: decodedTx7, isAGuestPost: isAGuestPost7 }
    }

    this.setState({phase: 9})

    //T3
    console.warn("GREAT7 so far. Next, walk the ZIG-ZAGGING transients of level 5. Will look at tx " + nextTx7)
    const {success: success8, fullyDone: fullyDone8, currentTx: currentTx8, nextTx: nextTx8, contentInfo: contentInfo8, dtx: decodedTx8, isAGuestPost: isAGuestPost8} = await this.walkTransientsWithoutDB(nextTx7, path, 10, 5, 5 === this.state.deepestTLevel)

    if (!success8) {
      alert("oh well :(  Failed to find the T5")
      return {success: false}
    }

    if ( fullyDone8 ) {
      console.warn("BTW: contentInfo8: ", contentInfo8)
      return {success: true, content: contentInfo8.inputParams.content, txId: currentTx8, dtx: decodedTx8, isAGuestPost: isAGuestPost8 }
    }

    this.setState({phase: 10})


    //T2
    console.warn("GREAT8 so far. Next, walk the ZIG-ZAGGING transients of level 4. Will look at tx " + nextTx8)
    const {success: success9, fullyDone: fullyDone9, currentTx: currentTx9, nextTx: nextTx9, contentInfo: contentInfo9, dtx: decodedTx9, isAGuestPost: isAGuestPost9} = await this.walkTransientsWithoutDB(nextTx8, path, 11, 4, 4 === this.state.deepestTLevel)

    if (!success9) {
      alert("oh well :(  Failed to find the T4")
      return {success: false}
    }

    if ( fullyDone9 ) {
      console.warn("BTW: contentInfo9: ", contentInfo9)
      return {success: true, content: contentInfo9.inputParams.content, txId: currentTx9, dtx: decodedTx9, isAGuestPost: isAGuestPost9 }
    }

    this.setState({phase: 11})

    //T1
    console.warn("GREAT9 so far. Next, walk the ZIG-ZAGGING transients of level 3. Will look at tx " + nextTx9)
    const {success: success10, fullyDone: fullyDone10, currentTx: currentTx10, nextTx: nextTx10, contentInfo: contentInfo10, dtx: decodedTx10, isAGuestPost: isAGuestPost10} = await this.walkTransientsWithoutDB(nextTx9, path, 12, 3, 3 === this.state.deepestTLevel)

    if (!success10) {
      alert("oh well :(  Failed to find the T3")
      return {success: false}
    }

    if ( fullyDone10 ) {
      console.warn("BTW: contentInfo10: ", contentInfo10)
      return {success: true, content: contentInfo10.inputParams.content, txId: currentTx10, dtx: decodedTx10, isAGuestPost: isAGuestPost10 }
    }

    this.setState({phase: 12})

    //T0
    console.warn("GREAT10 so far. Next, walk the ZIG-ZAGGING transients of level 2. Will look at tx " + nextTx10)
    const {success: success11, fullyDone: fullyDone11, currentTx: currentTx11, nextTx: nextTx11, contentInfo: contentInfo11, dtx: decodedTx11, isAGuestPost: isAGuestPost11} = await this.walkTransientsWithoutDB(nextTx10, path, 13, 2, 2 === this.state.deepestTLevel)

    if (!success11) {
      alert("oh well :(  Failed to find the T2")
      return {success: false}
    }

    if ( fullyDone11 ) {
      console.warn("BTW: contentInfo11: ", contentInfo11)
      return {success: true, content: contentInfo11.inputParams.content, txId: currentTx11, dtx: decodedTx11, isAGuestPost: isAGuestPost11 }
    }

    this.setState({phase: 13})




    //T1
    console.warn("GREAT11 so far. Next, walk the ZIG-ZAGGING transients of level 1. Will look at tx " + nextTx11)
    const {success: success12, fullyDone: fullyDone12, currentTx: currentTx12, nextTx: nextTx12, contentInfo: contentInfo12, dtx: decodedTx12, isAGuestPost: isAGuestPost12} = await this.walkTransientsWithoutDB(nextTx11, path, 14, 1, 1 === this.state.deepestTLevel)

    if (!success12) {
      alert("oh well :(  Failed to find the T1")
      return {success: false}
    }

    if ( fullyDone12 ) {
      console.warn("BTW: contentInfo12: ", contentInfo12)
      return {success: true, content: contentInfo12.inputParams.content, txId: currentTx12, dtx: decodedTx12, isAGuestPost: isAGuestPost12 }
    }

    this.setState({phase: 14})



    //T0
    console.warn("GREAT12 so far. Next, walk the ZIG-ZAGGING transients of level 0. Will look at tx " + nextTx12)
    const {success: success13, fullyDone: fullyDone13, currentTx: currentTx13, nextTx: nextTx13, contentInfo: contentInfo13, dtx: decodedTx13, isAGuestPost: isAGuestPost13} = await this.walkTransientsWithoutDB(nextTx12, path, 15, 0, 0 === this.state.deepestTLevel)

    if (!success13) {
      alert("oh well :(  Failed to find the T0")
      return {success: false}
    }

    if ( fullyDone13 ) {
      console.warn("BTW: contentInfo13: ", contentInfo13)
      return {success: true, content: contentInfo13.inputParams.content, txId: currentTx13, dtx: decodedTx13, isAGuestPost: isAGuestPost13 }
    }

    this.setState({phase: 15})

    alert("ERROR: We should've been done by now")
  }

  closeLoader() {
    this.setState({showLoader: false})
  }

  explainMore() {
    this.setState({showMore: true})
  }
  closeExplainMore() {
    this.setState({showMore: false})
  }

  // current txId passed by child (contentPresenter)
  // ADAPTED from shizzleView
  async shareLinkToPost(txId) {
    console.warn("linkJumper  shareLinkToPost(): ", txId)
    //console.log("decoded tx: ", this.state.decodedTx)

    const txState = JSON.parse( this.state.decodedTx )
    //const txState = await queryFunction( txId, await openDB(), false );
    console.log("txState: ", txState)

    const txAddress = txState.address.split("//")[1]
    console.warn("tx address: ", txAddress)

    const ourOrigin = window.location.href.split("/").slice(0, 3).join('/')
    const linkPath = ourOrigin + "/?j=" + txAddress

    console.warn("LinkPath: ", linkPath)

    try {
        await navigator.clipboard.writeText( linkPath );
        this.quickToast("Link copied to clipboard", 900, true)
        //alert("Link copied to clipboard")
    } catch (error ) {
      // sometimes:
      //   NotAllowedError: The request is not allowed by the user agent or the platform in
      //                    the current context, possibly because the user denied permission.
      // see: https://stackoverflow.com/questions/62327358/javascript-clipboard-api-safari-ios-notallowederror-message
      // tl;dr: "You are trying to copy to the clipboard as a result of an API call
      //         instead of in the context of a user interaction. This is not allowed."
      console.warn("shareLinkToPost(): error: ", error)
      alert("Use this link to share the post:\n\n"
          + linkPath
      )
      return
    }

  }

  // show a 'toast' for a specified period
  quickToast(toastText, duration=2000, withoutLoader = false) {
      console.warn("quickToast()")
      this.setState({showQuickToast: true, toastText: toastText, toastDuration: duration, suppressLoader: withoutLoader})
      // once expired, quickToastDone() will be called
  }
  // called-back by toast, once it's expired
  quickToastDone(self) {
      self.setState({showQuickToast: false, suppressLoader: false})

      // now that it's expired, do NOTHING
  }

  render() {

    if ( ! this.state.searchStarted && !this.searchStarted ) {
      this.startTheSearch( )
    }

    // ***  DEVICE-DEPENDENT STYLING  ***
    // For mobile, "detect" landscape screen mode
    const landscape = this.props.isMobile ? window.innerWidth > window.innerHeight : false
    // For mobile, shrink the About, Security, and Glossary modals
    const modalClassName   = this.props.isMobile ?
                                    (landscape ?
                                            "modalMobileLandscape"
                                        :
                                            "modalMobilePortrait"
                                    )
                                :
                                    ""
    const modalContentClassName = this.props.isMobile ? "modalContentMobile" : ""
    const modalBottomClassName  = this.props.isMobile ? "modalBottomMobile"  : ""

    const progressDisplay = <>
                              <b style={{color:'blue'}}>{this.state.phase}/{this.state.deepestPhase}</b>
                            </>

    const fetchingOrFetched = this.state.contentReady ? "You fetched" : "You're fetching"
    // icon sizes: mini tiny small large big huge massive
    const shzvrsExplainer = <Icon  size='large' style={{color: bshzColors.purple}} name='question circle outline' />
    const shzvrsExplainerText =
                                <>
                                  <p>
                                    It's early days for the <b style={{color:'blue'}}>ShizzleVerse</b>, a
                                    Bitcoin-powered world-wide web - where you actually <b>own</b> your identity, and
                                    profit directly from followers who appreciate your content.
                                  </p>
                                  <p>
                                    {fetchingOrFetched} Bitcoin-stored data "by yourself". In the future, service
                                    providers will compete to give you a faster experience.
                                  </p>
                                </>
    //<Label onClick={this.explainMore} color='violet' style={{color:bshzColors.purple}}>Learn more</Label>
    const popupShzVrsExplainer =  <>
                                    <Popup style={{backgroundColor: bshzColors.ltYellow}} trigger={shzvrsExplainer} wide="very" content={shzvrsExplainerText} hideOnScroll/>
                                    <span onClick={this.explainMore} style={{color:'blue', cursor:'pointer'}}>Learn more</span>
                                  </>

    const openProtocolExplainer = <span className='hoverLink' style={{color:'blue'}}>open protocol</span>
    const openProtocolExplainerText = <>
                                        An <b style={{color:'blue'}}>open protocol</b> is one that doesn't change, but is open for <b>anyone</b> to
                                        use. There are <b>no</b> gatekeepers in the ShizzleVerse. This means anyone can
                                        build and innovate here.
                                      </>
    const popUpOpenProtocolExplainer = <Popup style={{backgroundColor: bshzColors.ltYellow}}
                                              trigger={openProtocolExplainer}
                                              wide="very"
                                              content={openProtocolExplainerText}
                                              hideOnScroll
                                              popper={<div style={{ filter: 'none' }}></div>}
                                              />

    const maybeShowMore = this.state.showMore ?

          <Modal size='large' dimmer='blurring' centered className={modalClassName}  open={true} style={{backgroundColor: bshzColors.purple, borderRadius: '20px'}}>

            <Modal.Header style={{textAlign: 'center', backgroundColor: bshzColors.purple, borderRadius: '20px'}}>
                <span style={{color: bshzColors.yellow}}> About this post </span>
            </Modal.Header>

            <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: bshzColors.ltPurple}}>
              This content was posted in the <b style={{color:'blue'}}>ShizzleVerse</b>, and someone has shared a link
              to it.
              <br></br><br></br>

              You can think of the <b style={{color:'blue'}}>ShizzleVerse</b> as <b style={{color:'blue'}}>Bitcoin
              SV's</b> own <b>world wide web</b>, <b>social media</b>, and <b>TRULY private email</b> - all rolled together. But
              it's <b>more</b> than that. Content posted here is different because it's posted by people who <b>own</b> their
              digital identities, and it's built using publicly-available <b style={{color:'blue'}}>Bitcoin SV</b> transactions
              - <b>not</b> siloed and controlled at some proprietary server farm.
              <br></br><br></br>

              Imagine email that isn't snooped, or social media that isn't owned and controlled by a company.
              That's the <b style={{color:'blue'}}>ShizzleVerse</b> - built with an {popUpOpenProtocolExplainer} that's <b>set
              in stone</b>, and <b>controlled by no one</b>. There's much more to tell, but that's a good start.

            </Modal.Content>

            <Modal.Actions className={modalBottomClassName} style={{backgroundColor: bshzColors.purple, borderRadius: '0px 0px 20px 20px'}}>
                      <div style={{textAlign: 'center', margin: '0px 0px 10px 0px'}}>
                        <Button positive onClick={ this.closeExplainMore }
                                content='Got it'/>
                        <Button positive style={{color:'yellow'}} onClick={ this.props.handleJumpToHome }>
                                <span style={{fontSize:'1.3rem'}}>Get started in the ShizzleVerse</span>
                        </Button>
                      </div>
            </Modal.Actions>
          </Modal>
        :
          null

    const snailSymbol     = <span style={{fontSize:'2.0rem'}}>&#x1F40C;</span>
    const snailSymbolDim  = <span style={{fontSize:'2.0rem', opacity:'0.4'}}>&#x1F40C;</span>
    const turtleSymbol    = <span style={{fontSize:'2.0rem'}}>&#x1F422;</span>
    const turtleSymbolDim = <span style={{fontSize:'2.0rem', opacity:'0.4'}}>&#x1F422;</span>
    const rocketSymbol    = <span style={{fontSize:'2.0rem'}}>&#x1F680;</span>
    const rocketSymbolDim = <span style={{fontSize:'2.0rem', opacity:'0.4'}}>&#x1F680;</span>
    const theTurtle = this.state.dbPerms ? turtleSymbolDim : turtleSymbol
    const theRocket = this.state.dbPerms ? rocketSymbol : rocketSymbolDim
    const permissionCheckbox =  <>
                                  Allow us to save data to your browser: &nbsp;
                                  {theTurtle} &nbsp;
                                  <Checkbox toggle checked={this.state.dbPerms} onClick={this.toggleDbPerms}/>
                                  &nbsp; {theRocket}
                                </>

    // icon sizes: mini tiny small large big huge massive
    const scanExplainer = <Icon  size='large' style={{color: bshzColors.purple}} name='question circle outline' />
    const popUpScanExplainerText = this.state.dbPerms ?
                                  <>
                                    <p>
                                      By giving permission for this application to store some
                                      Bitcoin data in your browser, we may be able to speed-up things a bit.
                                    </p>
                                    <p>
                                      It doesn't take up much room, and you can have us delete it at any time.
                                    </p>
                                  </>
                                :
                                  <>
                                    <p>
                                      By giving permission for this application to store some
                                      Bitcoin data in your browser, we'll be able to speed-up things
                                      the <b>next</b> time.
                                    </p>
                                    <p>
                                      It doesn't take up much room, and you can have us delete it at any time.
                                    </p>
                                  </>
    const popupScanExplainer = <Popup style={{backgroundColor: bshzColors.ltYellow}} trigger={scanExplainer} wide="very" content={popUpScanExplainerText} hideOnScroll/>

    const maybeShowSpeedupOption = this.state.dbPerms ?
          <>
            We're cacheing intermediate transactions to your browser database.
          </>
        :
          <>
            Want to speed-up ShizzleVerse links?
          </>

    //const destinationLink = <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.rhs}</span>
    const destinationLink =
    this.state.phase === 0 ?
            <>
            <span style={{color: bshzColors.purple}}>shizzleverse://<span style={{color: 'grey'}}>{this.state.linkRHS[0]}</span>
            </span>
            </>
          :
            this.state.phase === 1 ?  // searching for domain - hi-light the letter currently being sought
                    <>
                    <span style={{color: bshzColors.purple}}>shizzleverse://<b style={{color:bshzColors.purple}}>{this.state.domainLHS}<span style={{fontSize:'2.0rem', color:'blue'}}>{this.state.domainCharBeingSought}</span></b></span><span style={{color: 'grey'}}>{this.state.domainRHS}</span>
                    <span style={{color: 'grey'}}>/{this.state.linkRHS[1]}</span>
                    </>
                  :
                    this.state.phase === 2 ?  // searching for ownerCount
                            <>
                            <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/</span>
                            <b style={{color: 'blue'}}>{this.props.path[1]}</b>
                            <span style={{color: 'grey'}}>/{this.state.linkRHS[2]}</span>
                            </>
                          :
                            this.state.phase === 3 ?  // searching for Quarterly
                                    <>
                                    <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/</span>
                                    <b style={{color: 'blue'}}>{this.props.path[2]}</b>
                                    <span style={{color: 'grey'}}>/{this.state.linkRHS[3]}</span>
                                    </>
                                  :
                                    this.state.phase === 4 ?  // searching for /U/Periodical
                                            <>
                                            <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/</span>
                                            <b style={{color: 'blue'}}>{this.props.path[3]}/{this.props.path[4]}</b>
                                            <span style={{color: 'grey'}}>/{this.state.linkRHS[5]}</span>
                                            </>
                                          :
                                            this.state.phase === 5 ?  // searching for /T/T9
                                                    <>
                                                      <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/</span>
                                                      <b style={{color: 'blue'}}>{this.props.path[5]}/{this.props.path[6]}</b>
                                                      <span style={{color: 'grey'}}>/{this.state.linkRHS[7]}</span>
                                                    </>
                                                  :
                                                    this.state.phase === 6 ?  // searching for T8
                                                            <>
                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/</span>
                                                              <b style={{color: 'blue'}}>{this.props.path[7]}</b>
                                                              <span style={{color: 'grey'}}>/{this.state.linkRHS[8]}</span>
                                                            </>
                                                          :
                                                            this.state.phase === 7 ?  // searching for T7
                                                                    <>
                                                                      <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/</span>
                                                                      <b style={{color: 'blue'}}>{this.props.path[8]}</b>
                                                                      <span style={{color: 'grey'}}>/{this.state.linkRHS[9]}</span>
                                                                    </>
                                                                  :
                                                                    this.state.phase === 8 ?  // searching for T6
                                                                            <>
                                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/</span>
                                                                              <b style={{color: 'blue'}}>{this.props.path[9]}</b>
                                                                              <span style={{color: 'grey'}}>/{this.state.linkRHS[10]}</span>
                                                                            </>
                                                                          :
                                                                            this.state.phase === 9 ?  // searching for T5
                                                                                    <>
                                                                                      <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/</span>
                                                                                      <b style={{color: 'blue'}}>{this.props.path[10]}</b>
                                                                                      <span style={{color: 'grey'}}>/{this.state.linkRHS[11]}</span>
                                                                                    </>
                                                                                  //EXPANDING FROM HERE
                                                                                  :
                                                                                    this.state.phase === 10 ?  // searching for T4
                                                                                            <>
                                                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/</span>
                                                                                              <b style={{color: 'blue'}}>{this.props.path[11]}</b>
                                                                                              <span style={{color: 'grey'}}>/{this.state.linkRHS[12]}</span>
                                                                                            </>
                                                                                          :
                                                                                            this.state.phase === 11 ?  // searching for T3
                                                                                                    <>
                                                                                                      <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/</span>
                                                                                                      <b style={{color: 'blue'}}>{this.props.path[12]}</b>
                                                                                                      <span style={{color: 'grey'}}>/{this.state.linkRHS[13]}</span>
                                                                                                    </>
                                                                                                  :
                                                                                                    this.state.phase === 12 ?  // searching for T2
                                                                                                            <>
                                                                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/</span>
                                                                                                              <b style={{color: 'blue'}}>{this.props.path[13]}</b>
                                                                                                              <span style={{color: 'grey'}}>/{this.state.linkRHS[14]}</span>
                                                                                                            </>
                                                                                                          :                           // search complete - but we never actually hit this phase
                                                                                                              //AGAIN, EXPANDING FROM HERE
                                                                                                            this.state.phase === 13 ?  // searching for T1
                                                                                                                    <>
                                                                                                                      <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/</span>
                                                                                                                      <b style={{color: 'blue'}}>{this.props.path[14]}</b>
                                                                                                                      <span style={{color: 'grey'}}>/{this.state.linkRHS[15]}</span>
                                                                                                                    </>
                                                                                                                  :
                                                                                                                    this.state.phase === 14 ?  // searching for T0
                                                                                                                            <>
                                                                                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/</span>
                                                                                                                              <b style={{color: 'blue'}}>{this.props.path[15]}</b>
                                                                                                                            </>
                                                                                                                          :
                                                                                                                            <>
                                                                                                                              <span style={{color: bshzColors.purple}}>shizzleverse://{this.props.path[0]}/{this.props.path[1]}/{this.props.path[2]}/{this.props.path[3]}/{this.props.path[4]}/{this.props.path[5]}/{this.props.path[6]}/{this.props.path[7]}/{this.props.path[8]}/{this.props.path[9]}/{this.props.path[10]}/{this.props.path[11]}/{this.props.path[12]}/{this.props.path[13]}/{this.props.path[14]}/{this.props.path[15]}</span>
                                                                                                                            </>
    // loader size:   mini tiny small medium large big huge massive
    // <Loader indeterminate inline style={{color: "blue"}} active size='big'>
    //   some text/message
    // </Loader>
    //FIXME: also try: <Icon size='huge' loading name='circle notch' color='purple'/>
    // also: cog, sun outline, sun, sync, spinner, compass,
    //       volleyball ball, plus circle, minus circle,plus, chain, ban, play,
    //       certificate, adjust, compress
    const maybeLoader = this.state.showLoader ?
                            <>
                                <div style={{backgroundColor:bshzColors.ltPurple}}>

                                  <br></br>
                                  <Icon size='huge' loading name='volleyball ball' color='purple'/>
                                  <br></br>
                                  <br></br>
                                  <div style={{fontSize:'1.3rem'}}>
                                    <span style={{color:'blue'}}>Now retrieving the ShizzleVerse link...</span>
                                    <br></br>
                                    <div style={{margin:'0px 0px 10px 0px'}}>
                                    {destinationLink}<span style={{fontSize:'2.0rem'}}>&nbsp;</span>
                                    </div>

                                    {progressDisplay}
                                    <br></br>
                                  </div>

                                  <br></br>
                                  <br></br>

                                </div>
                            </>
                          :
                            <>showLoader is false</>

    const maybeShowIdbOptions = this.state.idbSupported && !this.state.contentReady ?
          <>
            <div style={{margin:'0px 0px -10px 0px', padding:'0px'}}>
            {maybeShowSpeedupOption}  &nbsp; {popupScanExplainer}
            </div>
            <div style={{margin:'-10px 0px 0px 0px', padding:'0px'}}>
            {permissionCheckbox}
            </div>
          </>
        :
          <></>

    //FIXME: if we're not yet done with the search, offer option to
    //       revoke permission AFTER we're done retrieving the post
    const maybeShowAreYouSure = this.state.showAreYouSureModal ?

          <Modal size='fullscreen' centered className={modalClassName}  open={true} style={{backgroundColor: bshzColors.purple, borderRadius: '20px'}}>

            <Modal.Header style={{textAlign: 'center', backgroundColor: bshzColors.purple, borderRadius: '20px'}}>
                <span style={{color: bshzColors.yellow}}> Delete Cached Data ? </span>
            </Modal.Header>

            <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: bshzColors.ltPurple}}>
              Are you <b>sure</b> you want to <b>delete</b> Bitcoin data from your browser (data which may help us retrieve the next link you look for)?
            </Modal.Content>

            <Modal.Actions className={modalBottomClassName} style={{backgroundColor: bshzColors.purple, borderRadius: '0px 0px 20px 20px'}}>
                      <div style={{textAlign: 'center'}}>
                        <Button negative onClick={ this.revokePermission }
                                content='Yes'/>
                        <Button positive onClick={ this.closeAreYouSureModal }
                                content='Never mind'/>
                      </div>
            </Modal.Actions>
          </Modal>
        :
          null



    const myElements = [ // flat array of nodes and edges
          { // node n1
            group: 'nodes', // 'nodes' for a node, 'edges' for an edge
            // NB the group field can be automatically inferred for you but specifying it
            // gives you nice debug messages if you mis-init elements
      
      
            data: { // element data (put json serialisable dev data here)
              id: 'n1', // mandatory (string) id for each element, assigned automatically on undefined
              parent: 'nparent', // indicates the compound node parent id; not defined => no parent
              // (`parent` can be effectively changed by `eles.move()`)
            },
      
            // scratchpad data (usually temp or nonserialisable data)
            scratch: {
              _foo: 'bar' // app fields prefixed by underscore; extension fields unprefixed
            },
      
            position: { // the model position of the node (optional on init, mandatory after)
              x: 100,
              y: 100
            },
      
            selected: false, // whether the element is selected (default false)
      
            selectable: true, // whether the selection state is mutable (default true)
      
            locked: false, // when locked a node's position is immutable (default false)
      
            grabbable: true, // whether the node can be grabbed and moved by the user
      
            pannable: false, // whether dragging the node causes panning instead of grabbing
      
            classes: ['foo', 'bar'], // an array (or a space separated string) of class names that the element has
      
            // DO NOT USE THE `style` FIELD UNLESS ABSOLUTELY NECESSARY
            // USE THE STYLESHEET INSTEAD
            style: { // style property overrides 
              'background-color': 'red'
            }
          },
      
          { // node n2
            data: { id: 'n2' },
            renderedPosition: { x: 200, y: 200 } // can alternatively specify position in rendered on-screen pixels
          },
      
          { // node n3
            data: { id: 'n3', parent: 'nparent' },
            position: { x: 123, y: 234 }
          },
      
          { // node n4
            data: { id: 'n4' },
            position: { x: 223, y: 334 }
          },
      
          { // node nparent
            data: { id: 'nparent' }
          },
      
          { // edge e1
            data: {
              id: 'e1',
              // inferred as an edge because `source` and `target` are specified:
              source: 'n1', // the source node id (edge comes from this node)
              target: 'n2'  // the target node id (edge goes to this node)
              // (`source` and `target` can be effectively changed by `eles.move()`)
            },
      
            pannable: true // whether dragging on the edge causes panning
          },
      
          { // edge e1
            data: {
              id: 'e2',
              // inferred as an edge because `source` and `target` are specified:
              source: 'n3', // the source node id (edge comes from this node)
              target: 'n4'  // the target node id (edge goes to this node)
              // (`source` and `target` can be effectively changed by `eles.move()`)
            },
      
            pannable: true // whether dragging on the edge causes panning
          },
          { // edge e1
            data: {
              id: 'e3',
              // inferred as an edge because `source` and `target` are specified:
              source: 'n2', // the source node id (edge comes from this node)
              target: 'n3'  // the target node id (edge goes to this node)
              // (`source` and `target` can be effectively changed by `eles.move()`)
            },
      
            pannable: true // whether dragging on the edge causes panning
          }
        ]
    // THIS 'WORKS' (renders):
    //<CytoscapeComponent elements={myElements} style={ { width: '600px', height: '600px' } } />;


    //jumpToLinkedAsset={ this.jumpToTx }
    //shareLinkToContent={ this.shareLinkToPost }
    //{hexStringToAscii(this.state.content)}  simplest display of content
    //NOTE: prop submode='LJ' merely sets (overrides) the height of the <ContentPresenter>'s <iframe>
    const loaderOrContent = this.state.contentReady ?
          <>
            <div style={{textAlign: 'center', backgroundColor:bshzColors.ltPurple}}>
              <br></br>
              <span style={{color: 'blue'}}>shizzleverse://{this.props.rhs}</span>
            </div>
            <div style={{backgroundColor:bshzColors.ltPurple}}>
              <br></br>
              <ContentPresenter
                  contentPresenterTx={this.state.txId}
                  domainOfInterest={this.props.path[0]}
                  parent={this}
                  decodedTx={this.state.decodedTx}
                  guestPost={this.state.isAGuestPost}

                  shareLinkToContent={ this.shareLinkToPost }

                  submode='LJ'
                  contentPending={this.state.contentPending}
                  contentEncrypted={this.state.contentEncrypted}
                  />
              <br></br>
            </div>
          </>
        :
          <>
            <div style={{textAlign: 'center'}}>

                <br></br>
                Please wait while we retrieve the <b style={{color:'blue'}}>Bitcoin transactions</b> that lead to this post...

                <br></br>
                <br></br>

                {maybeLoader}

            </div>
          </>

    const absoluteBuffer = this.state.contentReady ?
        <>
        </>
      :
        <>
          <br></br>
          <br></br>
          <br></br>
        </>
    const absoluteLearnMore =
        <div style={{position:'absolute', margin:'8px'}}>
          {absoluteBuffer}
          {popupShzVrsExplainer}
        </div>
    const absoluteExtra =
        <div style={{position:'absolute', marginLeft:'auto', marginRight:'auto',left:'0',right:'0',textAlign: 'center'}}>
          <br></br>
          <br></br>
          <br></br>
          <Icon size='huge' loading name='cog' color='blue' style={{fontSize:'6rem'}}/>
        </div>

    const maybeQuickToast = this.state.showQuickToast ?
            <>
            <Toast  durationMillis={this.state.toastDuration}
                displayText={this.state.toastText}
                noLoader={this.state.suppressLoader}
                done={this.quickToastDone}
                parent={this}/>
            </>
        :
            <></>

    // NOTE: the pop-up explainer icon has absolute position:
    //       see: https://stackoverflow.com/questions/16236142/two-divs-on-same-position
    return (
      <>
      <div style={{position:'relative'}}>
        {absoluteLearnMore}
        {loaderOrContent}
      </div>

      {maybeShowIdbOptions}

      {maybeShowAreYouSure}
      {maybeShowMore}
      {maybeQuickToast}
      </>
          )
  }
}

export default LinkJumper;
